import { CustomerQuestionAnswer, QuestionAnswer } from "../models/question.model";

export namespace PermitQuestionActions {
    export class GetNextQuestion {
        public static readonly type = "[PermitQuestion] GetNextQuestion";
    }

    export class GetPermit {
        public static readonly type = "[PermitQuestion] GetPermit";
        constructor(public permitId: number) {}
    }

    export class GetPermitAndCurrentQuestion {
        public static readonly type = "[PermitQuestion] GetPermitAndCurrentQuestion";
        constructor(public permitId?: number) {}
    }

    export class GetCurrentQuestion {
        public static readonly type = "[PermitQuestion] GetCurrentQuestion";
    }

    export class GetPreviousQuestion {
        public static readonly type = "[PermitQuestion] GetPreviousQuestion";
    }

    export class ResetToDefault {
        public static readonly type = "[PermitQuestion] ResetToDefault";
    }

    export class SetFixedOrCustomerQuestionAnswer {
        public static readonly type = "[PermitQuestion] SetQuestionAnswer";
        constructor(public answer: QuestionAnswer) {}
    }

    export class SaveQuestionAnswer {
        public static readonly type = "[PermitQuestion] SaveQuestionAnswer";
        constructor(public answer: QuestionAnswer) {}
    }

    export class SaveCheckpointAnswer {
        public static readonly type = "[PermitQuestion] SaveCheckpointAnswer";
        constructor(public checkpointId: number, public answer: CustomerQuestionAnswer) {}
    }
}
